export abstract class AbstractCoreEnvService {
  abstract getBaseURL(): string
}
